import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const mapStateToProps = ({ language }) => ({ language });

const StyledForm = styled.form`
  display: flex;
  gap: 10px;
`;

const StyledInputWrapper = styled.div`
  border: 1px solid #cccccc;
  padding-left: 0.5rem;
  height: 40px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  @media only screen and (max-width: 768px) {
    padding-left: 0.25rem;
  }
  > div {
    width: 100%;
  }
`;

const StyledNumber = styled(StyledInputWrapper)`
  width: 60%;
`;

const StyledContainer = styled(StyledInputWrapper)`
  width: 20%;
`;

const StyledErrors = styled.div`
  margin: 1rem 0;
  color: #eb1c26;
  text-align: center;
`;

const StripeForm = ({ language, id, handleChange, validationError, serverError }) => (
  <div className="form-row">
    {/* eslint-disable-next-line jsx-a11y/label-has-for */}
    <label
      id="stripe-payment-label"
      htmlFor="card-element"
      style={{
        display: 'block',
        textAlign: 'center',
      }}
    >
      {language[`returns.stripe.${id}.card_title`] || language[`returns.stripe_card_title`]}
    </label>
    <StyledForm className="fs-exclude">
      <StyledNumber>
        <CardNumberElement
          id="stripe-card-number-element"
          options={{
            showIcon: true,
            placeholder:
              language[`returns.stripe.${id}.card_number_placeholder`] ||
              language[`returns.stripe_card_number_placeholder`],
          }}
          className="stripe-card-number stripe-element"
          onChange={handleChange}
        />
      </StyledNumber>
      <StyledContainer>
        <CardExpiryElement
          id="stripe-card-expiry-element"
          options={{
            placeholder:
              language[`returns.stripe.${id}.card_expiry_placeholder`] ||
              language[`returns.stripe_card_expiry_placeholder`],
          }}
          className="stripe-card-expiry stripe-element"
          onChange={handleChange}
        />
      </StyledContainer>
      <StyledContainer>
        <CardCvcElement
          id="stripe-card-cvc-element"
          options={{
            placeholder:
              language[`returns.stripe.${id}.card_cvc_placeholder`] ||
              language[`returns.stripe_card_cvc_placeholder`],
          }}
          className="stripe-card-cvc stripe-element"
          onChange={handleChange}
        />
      </StyledContainer>
    </StyledForm>
    <StyledErrors className="card-errors" role="alert">
      {validationError || serverError}
    </StyledErrors>
  </div>
);

StripeForm.propTypes = {
  language: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  validationError: PropTypes.string.isRequired,
  serverError: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(StripeForm);
